import { createTheme } from "@mui/material";
import { breakpoints } from "./BreakingPoints";
import { colors, palette, Colors } from "./Colors";
import { images, ImageType } from "./Images";
import { fontSizes, FontSizes } from "./FontSizes";
declare module "@mui/material/styles" {
  interface Theme {
    status?: {
      danger?: string;
    };
    boxShadow?: {
      primary: string;
      secondary: string;
    };
    colors: Colors;
    images: ImageType;
    fontSizes: FontSizes;
  }
  interface ThemeOptions {
    status?: {
      danger?: string;
    };
    boxShadow?: {
      primary: string;
      secondary: string;
    };
    colors: Colors;
    images: ImageType;
    fontSizes: FontSizes;
  }
}

const createThemeWithRtlSupport = (isRtl: boolean) =>
  createTheme({
    direction: isRtl ? "rtl" : "ltr",
    breakpoints,
    boxShadow: {
      primary: "0 0 9px 0 rgba(108,116,133,0.24)",
      secondary: "0 0 12px 0 rgba(108,116,133,0.24)",
    },
    zIndex: {},
    palette: palette,
    colors: colors,
    images: images,
    fontSizes: fontSizes,
  });

const ltrTheme = createThemeWithRtlSupport(false);
const rtlTheme = createThemeWithRtlSupport(true);

export { ltrTheme, rtlTheme };
